import React, { useContext, useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import { ApiContext } from '@api/api.tsx';
import { LovWithoutIdDTO } from '@api/ringil-api.v2.tsx';
import { CustomsTypeComponent } from '@components/obsolete/CloComponent/CloComponent.tsx';
import SvgCustoms from '@icons/Customs.svg?react';

interface ComponentProps {
  secured?: SecuredConfig;
  value: string;
  onChange: (code: string) => void;
  required?: boolean;
  readOnly?: boolean;
  errorMessage?: string;
  dataTestId?: string;
}

const CustomsRegimeTag: React.FC<ComponentProps> = ({ secured, value, onChange, required, readOnly, errorMessage, dataTestId }) => {
  const { tr } = useTranslationLgs();
  const { lovCustomsTypes } = useContext(ApiContext);
  const [customsTypes, setCustomsTypes] = useState<LovWithoutIdDTO[]>([]);
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    lovCustomsTypes(d => setCustomsTypes(d));
  }, []);

  useEffect(() => setInternalValue(value), [value]);

  const name = customsTypes.find(c => c.code === value)?.name;

  return (
    <ButtonTag
      secured={secured}
      label={tr('CustomsRegimeTag.label', 'Customs type')}
      icon={<SvgCustoms />}
      value={name}
      required={required}
      readonly={readOnly}
      errorMessage={errorMessage}
      onSave={onSuccess => {
        onChange(internalValue);
        onSuccess();
      }}
      autoClose
      dataTestId={dataTestId}
    >
      <CustomsTypeComponent value={internalValue} onChange={v => setInternalValue(v)} dataTestId={dataTestId ? `${dataTestId}-select` : undefined} options={customsTypes} />
    </ButtonTag>
  );
};

export default CustomsRegimeTag;
